module.exports = __webpack_public_path__ + "img/Full-Map-new.e3dbf273.svg";